import React from "react";
import {
  Container,
  Segment,
  Header,
  Icon,
  Grid,
  Card,
  Button,
  Label,
} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";

const PanelTrabajoTecnicoST = () => {
  const navigate = useNavigate();
  const user = auth.currentUser;

  const accesos = [
    {
      titulo: "Nueva Orden de Ingreso",
      descripcion: "Registrar un nuevo equipo que ingresa al servicio técnico.",
      icon: "plus circle",
      color: "teal",
      path: "/serviciotecnico/ingreso",
    },
    {
      titulo: "Mis Órdenes",
      descripcion: "Ver y trabajar las órdenes asignadas a mi usuario.",
      icon: "clipboard list",
      color: "blue",
      path: "/serviciotecnico/asignadostecnicos",
    },
  ];

  return (
    <Container fluid style={{ padding: 24 }}>
      <Segment
        raised
        style={{
          borderRadius: 18,
          border: "1px solid #e5e7eb",
          boxShadow: "0 14px 35px rgba(15, 23, 42, 0.08)",
          padding: 28,
        }}
      >
        <Header as="h2">
          <Icon name="wrench" color="teal" />
          <Header.Content>
            Panel de Trabajo
            <Header.Subheader>
              Servicio Técnico — {user?.email || "Técnico"}
            </Header.Subheader>
          </Header.Content>
        </Header>

        <Label color="blue" basic>
          TECNICO-LMST
        </Label>

        <Grid stackable columns={2} style={{ marginTop: 24 }}>
          {accesos.map((item) => (
            <Grid.Column key={item.titulo}>
              <Card fluid color={item.color}>
                <Card.Content textAlign="center">
                  <Icon
                    name={item.icon}
                    size="huge"
                    color={item.color}
                    style={{ marginBottom: 14 }}
                  />

                  <Header as="h3">{item.titulo}</Header>

                  <p style={{ color: "#64748b", minHeight: 44 }}>
                    {item.descripcion}
                  </p>
                </Card.Content>

                <Card.Content extra>
                  <Button
                    fluid
                    color={item.color}
                    onClick={() => navigate(item.path)}
                  >
                    Abrir
                    <Icon name="arrow right" />
                  </Button>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
        </Grid>
      </Segment>
    </Container>
  );
};

export default PanelTrabajoTecnicoST;